import React from "react";
import PropTypes from "prop-types";
import ArticleGrid from "./ArticleGrid";
import Header from "./Header";

const Landing = ({ data }) => (
  <div className="full-container">
    <Header info={data.header} />
    <ArticleGrid data={data} />
  </div>
);

Landing.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Landing;
